<ion-header analyticsCategory="MENU" class="ion-no-border">
  <!-- PWA -->
  <ion-toolbar *ngIf="!ctx.isApp">
    <ion-buttons slot="start">
      <ion-button mode="md" class="btn-dismiss" (click)="menuCtrl.close()">
        <ion-icon color="dark" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <!-- APP NOT LOGGED -->
  <ion-toolbar *ngIf="ctx.isApp && !authState.isLogged">
    <ion-buttons slot="start">
      <ion-button mode="md" class="btn-dismiss" (click)="menuCtrl.close()">
        <ion-icon color="dark" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <!-- APP LOGGED -->
  <ion-toolbar *ngIf="ctx.isApp && authState.isLogged" class="app-header">
    <div class="app-header__section-1">
      <ion-button mode="md" class="btn-icon" (click)="menuCtrl.close()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
      <div class="badge" (click)="navTo(inboxItem)">
        <ion-icon src="assets/images/header/email-dark.svg"></ion-icon>
        <div *ngIf="menu.unreadMails$ | async as unread" class="badge__number">
          <div>{{ unread < 100 ? unread : 99 }}</div>
        </div>
      </div>
    </div>
    <div class="app-header__section-2">
      <div class="app-header__profile">
        <div class="app-header__titles-box">
          <span class="app-header__title">{{
            authState.user?.name | titlecase
          }}</span>
          <ng-container *ngIf="teCuidamosState?.customerRating; else skeleton">
            <div class="app-header__subtitles-box t-upper">
              <span [ngSwitch]="teCuidamosState.customerRating">
                <span *ngSwitchCase="1"
                  >{{ 'TECUIDAMOS.RATING_TYPE.CLIENT' | translate }}{{ 'TECUIDAMOS.RATING_TYPE.PLATINUM' | translate }}</span
                >
                <span *ngSwitchCase="2"
                  >{{ 'TECUIDAMOS.RATING_TYPE.CLIENT' | translate }}{{ 'TECUIDAMOS.RATING_TYPE.GOLD' | translate }}</span
                >
                <span *ngSwitchCase="3"
                  >{{ 'TECUIDAMOS.RATING_TYPE.CLIENT' | translate }}{{ 'TECUIDAMOS.RATING_TYPE.SILVER' | translate }}</span
                >
                <span *ngSwitchDefault></span>
              </span>
              <mat-divider
                class="app-header__separator"
                vertical="true"
              ></mat-divider>
              <span>
                {{
                  (teCuidamosState?.redeemPendingClovers | numberFloor: 0) || 0
                    | number: '1.0-0'
                }}
                {{
                  teCuidamosState?.redeemPendingClovers > 0 &&
                  teCuidamosState?.redeemPendingClovers < 2
                    ? ' Trébol'
                    : ' Tréboles'
                }}
              </span>
            </div>
          </ng-container>
          <ng-template #skeleton>
            <div class="app-header__subtitles-box app-header__subtitles-box--skeleton">
              <ion-skeleton-text animated></ion-skeleton-text>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
    <div class="app-header__section-3">
      <ion-button
        class="app-header__btn-profile"
        slot="end"
        fill="outline"
        (click)="onProfile()"
      >
      <div class="app-header__btn-profile--text">{{ 'CORE.MENU.YOUR_PROFILE' | translate }}</div>
      </ion-button>
    </div>
  </ion-toolbar>
</ion-header>

<ion-content
  #content
  analyticsCategory="MENU"
  [ngClass]="{ 'app-height': ctx.isApp && authState.isLogged }"
  disableScrollShadow
>
  <div
    class="content__box"
    [ngClass]="{ 'content-box--login': ( ctx.isApp && !authState.isLogged ) || !ctx.isApp }"
  >
    <div>
      <ng-container *ngFor="let item of items; let i = index">
        <ng-template [ngIf]="item.childs">
          <mat-expansion-panel #expandableItem class="menu-expansion">
            <mat-expansion-panel-header
              matRipple
              class="menu-expansion__header"
              expandedHeight="56px"
              collapsedHeight="56px"
            >
              <mat-panel-title>
                <span class="mapfre-fs-s dark-secondary">{{ item.title }}</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div>
              <ng-container *ngFor="let child of item.childs">
                <button
                  matRipple
                  class="menu-btn menu-btn--child"
                  (click)="navTo(child)"
                >
                  <span class="mapfre-fs-s dark-secondary">{{ child.title }}</span>
                </button>
              </ng-container>
            </div>
          </mat-expansion-panel>
        </ng-template>

        <ng-template [ngIf]="!item.childs">
          <div
            class="menu-btn__box"
          >
            <button
              class="menu-btn df fd-row ai-c"
              matRipple
              (click)="navTo(item)"
              [ngClass]="{
                'mapfre-hide':
                  (item.isEnabled && !(item.isEnabled | async)) ||
                  (item.hideOnWeb && !ctx.isApp),
                'mapfre-hide-desktop': item.pwaHideOnDesktop && !ctx.isApp
              }"
            >
              <span class="mapfre-fs-s dark-secondary">{{ item.title }}</span>
            </button>
          </div>
        </ng-template>
      </ng-container>
    </div>

    <div
      class="content__version mapfre-fw-500 mapfre-fs-s"
    >
      {{ 'CORE.MENU.VERSION' | translate }} {{ version }}
    </div>
  </div>
</ion-content>

<!-- APP -->
<ion-footer *ngIf="ctx.isApp && authState.isLogged" class="app-footer">
  <a class="app-footer__link" (click)="onContacts()">
    <ion-icon src="assets/images/menu/call.svg"></ion-icon>
    {{ 'INFO' | translate }}
  </a>
  <a class="app-footer__link" (click)="onLogout()">
    <ion-icon src="assets/images/menu/logout.svg"></ion-icon>
    {{ 'CORE.LOGOUT.CLOSE_SESSION' | translate }}
  </a>
</ion-footer>
